// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__eZWbR","imageSection":"Login_imageSection__EB0Hw","formSection":"Login_formSection__G+x18"};